import { render, staticRenderFns } from "./PregledPodsetnikaVozila.vue?vue&type=template&id=91f2efb0&scoped=true&"
import script from "./PregledPodsetnikaVozila.vue?vue&type=script&lang=ts&"
export * from "./PregledPodsetnikaVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f2efb0",
  null
  
)

export default component.exports